import { isObjectLike } from '@scalar/helpers/object/is-object';
/**
 * Encodes a path parameter, preserving only path-safe reserved characters and
 * existing percent-encoded triples when OpenAPI reserved expansion is enabled.
 * Slashes, query/fragment delimiters, and brackets must remain escaped.
 */
export const encodePathParameter = (value, allowReserved = false) => {
    if (!allowReserved) {
        return encodeURIComponent(value);
    }
    return value.replace(/%[0-9a-f]{2}|[\s\S]/giu, (character) => /^%[0-9a-f]{2}$/i.test(character) || /^[!$&'()*+,;=:@]$/.test(character)
        ? character
        : encodeURIComponent(character));
};
/** Serializes OpenAPI reserved path expansion without exposing forbidden delimiters. */
export const serializeReservedPathParameter = (name, parameter, replace = (value) => value) => {
    const { value, style, explode } = parameter;
    const encode = (item) => encodePathParameter(replace(String(item)), true);
    const entries = isObjectLike(value) && !Array.isArray(value) ? Object.entries(value) : undefined;
    const array = Array.isArray(value) ? value : undefined;
    if (style === 'matrix') {
        if (entries && explode) {
            return entries.map(([key, item]) => `;${encode(key)}=${encode(item)}`).join('');
        }
        if (array && explode) {
            return array.map((item) => `;${encode(name)}=${encode(item)}`).join('');
        }
        const parts = entries ? entries.flatMap(([key, item]) => [key, item]) : (array ?? [value]);
        const data = parts.map(encode).join(',');
        return `;${encode(name)}=${data}`;
    }
    const delimiter = style === 'label' && explode ? '.' : ',';
    let data;
    if (entries) {
        data = entries
            .map(([key, item]) => (explode ? `${encode(key)}=${encode(item)}` : `${encode(key)}${delimiter}${encode(item)}`))
            .join(delimiter);
    }
    else {
        data = array ? array.map(encode).join(delimiter) : encode(value);
    }
    return style === 'label' ? `.${data}` : data;
};
/** Rejects dot segments that browser URL parsing would silently remove. */
export const assertReservedPathUrl = (url) => {
    const path = url.split(/[?#]/, 1)[0] ?? '';
    if (path.split('/').some((segment) => /^(?:\.|%2e){1,2}$/i.test(segment))) {
        throw new URIError('Reserved path parameters cannot form dot segments because browsers normalize them.');
    }
};
